import { locale } from '@/helpers/locale'

export function formatPrice(price: number | string = '', currency = ''): string {
  const number = parseFloat(String(price))
  const fraction = number - Math.floor(number);

  // If the fraction is less than 0.01 (e.g. 0.001), treat it as though it's a whole number
  const fractionDigits = fraction < 0.01 ? 0 : 2;

  return number.toLocaleString(locale, {
    style: 'currency',
    minimumFractionDigits: fractionDigits,
    currency,
  });
}
